var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 30V2h16.1c1.43.175 4.655 1.068 6.125 3.238 1.837 2.712.962 7 0 7.962-.77.77-2.538 1.838-3.325 2.275 1.37.262 4.323 1.47 5.163 4.2 1.05 3.413-.244 6.333-1.4 7.875C25.35 29.3 22.9 30 20.8 30H4zm7.7-21.875v4.9H18c.583-.204 1.75-.98 1.75-2.45S18.583 8.33 18 8.125h-6.3zm0 10.675v4.9h6.825c.583-.204 1.75-.98 1.75-2.45s-1.167-2.246-1.75-2.45H11.7z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtse);
export default __webpack_public_path__ + "static/media/BTSE.45e276806e712e024cd7bd389d31b10e.svg";
export { ForwardRef as ReactComponent };